import { Tab, TabAppearance, TabList, Tabs, TabSize, Text } from '@talos/kyoko';
import type { QuotesV2GroupBy, QuotesV2GroupByOption } from './useQuotesV2GroupBy';

interface QuotesV2GroupByButtonsProps {
  selectedGroupBy?: QuotesV2GroupBy;
  options: QuotesV2GroupByOption[];
  onChange: (groupBy: QuotesV2GroupBy) => void;
}

export function QuotesV2GroupByButtons({ selectedGroupBy, options, onChange }: QuotesV2GroupByButtonsProps) {
  if (options.length === 0) {
    return null;
  }

  return (
    <>
      <Text size="fontSizeSm" color="colorTextSecondary">
        Group by
      </Text>
      <Tabs
        selectedIndex={options.findIndex(option => option.value === selectedGroupBy)}
        appearance={TabAppearance.Pill}
        size={TabSize.Small}
        flex="0 0 auto"
        w="auto"
        data-testid="quotes-v2-group-by-buttons"
      >
        <TabList suppressOverflowList={true}>
          {options.map(option => (
            <Tab
              key={option.value}
              isSelected={selectedGroupBy === option.value}
              onClick={() => onChange(option.value)}
              data-testid={option.testID}
              label={option.label}
            />
          ))}
        </TabList>
      </Tabs>
    </>
  );
}
